const buildTerm = (term = defaultTerm) => {
  return {
    term: term,
    lowercase_singular: `settings.business_page.business_terminology.terms.${term}.lowercase_singular`,
    lowercase_plural: `settings.business_page.business_terminology.terms.${term}.lowercase_plural`,
    capitalized_singular: `settings.business_page.business_terminology.terms.${term}.capitalized_singular`,
    capitalized_plural: `settings.business_page.business_terminology.terms.${term}.capitalized_plural`,
    icon: term === defaultTerm ? defaultIcon : `icon-icon-${term}-solid`
  }
};

const defaultTerm = 'clients';
const defaultIcon = 'icon-icon-Clients';

export default {
  buildTerm,
  defaultTerm
};
